import React, {useEffect, useState} from 'react';
import {bindActionCreators, compose} from 'redux';
import * as rubricsActions from '../../../actions/rubricsActionCreators';
import * as productsActions from '../../../actions/productsActionCreators';
import {connect} from 'react-redux';
import ProductsList from '../../../components/ProductsList';
import Paginator from '../../../components/Paginator';
import {useUnmount} from 'react-use';
import ProductsFilters from '../../../components/ProductsFilters';
import ProductsSort from '../../../components/ProductsSort';
import MobileProductsFilters from '../../../components/ProductsFilters/MobileFilters';
import Button from '../../../components/Button';
import {productsCountFrom} from '../../../tools/formatters';
import {parseQueryString, textKeysReplacement, urlParamsToObject} from '../../../tools/helpers';
import SeoTags from '../../../routes/SeoTags';
import InfiniteScroll from "react-infinite-scroller";
import LoadingSpinner from '../../../components/Loading';
const ProductRubric = ({rubric, ...props}) => {
  const
    {possibleProductsCount} = props.productsState,
    filtersOn = !!Object.keys(props.productsState.filters).length,
    handleApplyFilters = () => {
      props.productsActions.applyProductsFilters();
      window.scroll({top: 0, left: 0, behavior: 'smooth'});
    },
    countStr = possibleProductsCount ? `${possibleProductsCount} ${productsCountFrom(possibleProductsCount)}` : '',

    [currentRubricId, setCurrentRubricId] = useState(null),
    handlePaginatorChanged = (page, perPage) => {
      props.productsActions.paginatorChanged(page, perPage);
    },
    {is_mobile} = props.applicationState;

  useUnmount(() => {
    props.productsActions.resetProducts();
  });

  useEffect(() => {
    if (rubric.id === currentRubricId) return;
    const
      query = window.location.search;
    let params:any;

    if (query.includes('catalogue')) {
      const
        scopeFilterMap = {
          latest: 'latests',
          hit: 'hits',
          stock: 'stocks'
        },
        oldStyleParams:any = parseQueryString(query);
      params = {};

      oldStyleParams.page && (params.page = oldStyleParams.page);
      oldStyleParams.per_page && (params.per_page = oldStyleParams.per_page);
      ['latest', 'stock', 'hit'].forEach(filter => {
        if (oldStyleParams.catalogue_filters?.[filter]) {
          if (params.scope_filters) {
            params.scope_filters.push(scopeFilterMap[filter]);
          } else {
            params.scope_filters = [scopeFilterMap[filter]];
          }
        }
      });
      oldStyleParams.catalogue_filters?.reminder && (params.reminder = oldStyleParams.catalogue_filters?.reminder);
      oldStyleParams.catalogue_filters?.with_price_only && (params.withou_price = !!Number(oldStyleParams.catalogue_filters?.with_price_only));
      oldStyleParams.catalogue_filters?.brands && (params.brands = oldStyleParams.catalogue_filters?.brands);
      if (Number(params.brands)) {
        params.brands = [Number(params.brands)];
      }
      oldStyleParams.catalogue_filters?.purposes && (params.purposes = oldStyleParams.catalogue_filters?.purposes);
      oldStyleParams.catalogue_trait_filters && (params.traits = oldStyleParams.catalogue_trait_filters);
      oldStyleParams.catalogue_filters?.cost_range && (params.price = [oldStyleParams.catalogue_filters?.cost_range?.cost_from || 0, oldStyleParams.catalogue_filters?.cost_range?.cost_to || 0]);
    } else {
      params = urlParamsToObject(query);
    }

    // same parsing as ProductsController#spa_products_page on SSR
    const paginator: any = {};
    if (Number(params.page) > 1) {
      paginator.page = Number(params.page);
      Number(params.per_page) > 0 && (paginator.per_page = Number(params.per_page));
    }
    delete params.page;
    delete params.per_page;

    const sort: any = {};
    if (params.sort_name && params.sort_dest) {
      sort.name = params.sort_name;
      sort.dest = params.sort_dest;
    }
    delete params.sort_name;
    delete params.sort_dest;

    props.productsActions.initProductsListing(params, paginator, sort);
    props.productsActions.fetchProducts(rubric.id);
    props.productsActions.fetchProductsFilterContext(rubric.id);

    setCurrentRubricId(rubric?.id);
  }, [rubric?.id, props.productsActions.fetchProducts]);

  const
    paginator = props.productsState.paginator,
    maxPage = Math.ceil(paginator.total / paginator.per_page),
    canLoadMore = !props.productsState.preloading_next_page && maxPage >= paginator.page,
    loadMoreProducts = () => {
      if (!canLoadMore) {
        return;
      }
      props.productsActions.preloadNextPage();
    };

  return (
    <div className='two-cols-container'>
      <SeoTags
        controller_action='products#index'
        seo_context={{
          title: textKeysReplacement(rubric.seo_title, props.applicationState.default_seo_context) || rubric.title,
          products_count: rubric.active_products_count || 0,
          description: textKeysReplacement(rubric.seo_description, props.applicationState.default_seo_context) || rubric?.description?.substring(0, 200),
          keywords: textKeysReplacement(rubric.seo_keywords, props.applicationState.default_seo_context),
        }}
      />

      {
        !is_mobile ?
          <div className='two-cols-container__col two-cols-container__col_left'>
            <ProductsFilters
              state={props.productsState}
              actions={props.productsActions}
            />
            {
              filtersOn && possibleProductsCount ?
                <Button primary onClick={handleApplyFilters}>{`Показать ${countStr}`}</Button>
                : null
            }
          </div>
          : null
      }
      <div className='two-cols-container__col two-cols-container__col_right'>
        <>
          <div className='products-sort-and-filters-wrapper'>
            <ProductsSort
              state={props.productsState}
              actions={props.productsActions}
            />
            {
              is_mobile ?
                <MobileProductsFilters
                  state={props.productsState}
                  actions={props.productsActions}
                />
                : null
            }
          </div>
          <InfiniteScroll
            pageStart={0}
            loadMore={loadMoreProducts}
            hasMore={canLoadMore}
            loader={<span key={0} />
              // <div className="products-loader" key={0}>
              //   <LoadingSpinner />
              // </div>
            }
            threshold={100}
          >
            <ProductsList products={props.productsState.collection} showSkeleton={!props.productsState.collection_loaded} listClass='infinite' />
            {
              props.productsState.preloading_next_page ?
                <div className="products-loader" key={0}>
                  <LoadingSpinner />
                </div>
                : null
            }
          </InfiniteScroll>
          {
            props.productsState.preloading_next_page ?
              <div className="products-loader" key={0}>
                <LoadingSpinner />
              </div>
              : null
          }
          {/*<Paginator {...props.productsState.paginator} onChange={handlePaginatorChanged}/>*/}
        </>
      </div>
    </div>
  )
}


const
  mapDispatchToProps = (dispatch) => {
    return {
      rubricsActions: bindActionCreators(rubricsActions, dispatch),
      productsActions: bindActionCreators(productsActions, dispatch),
    };
  },
  mapStateToProps = ({rubricsState, railsContext, applicationState, productsState}) => {
    return {
      applicationState,
      rubricsState,
      productsState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default compose(withConnect)(ProductRubric);
